export { default } from './StockCarCard';
